import { useTheme } from "../hooks/useTheme";

/**
 * Sun / moon toggle.
 *
 * Shows the theme you would switch TO, which is the convention people expect from
 * this control: a moon means "go dark". The title says whether the current theme is
 * being followed from the system, since that is otherwise invisible.
 */
export function ThemeToggle({ className = "" }: { className?: string }) {
  const { theme, toggle, isFollowingSystem } = useTheme();
  const goingTo = theme === "dark" ? "light" : "dark";

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={`Switch to ${goingTo} mode`}
      title={
        isFollowingSystem
          ? `Following your system (${theme}). Click for ${goingTo} mode.`
          : `${theme[0].toUpperCase()}${theme.slice(1)} mode. Click for ${goingTo} mode.`
      }
      className={`rounded p-1.5 text-current transition-colors hover:bg-white/10 ${className}`}
    >
      {theme === "dark" ? <SunIcon /> : <MoonIcon />}
    </button>
  );
}

function SunIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4" />
      <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
    </svg>
  );
}
